export default {
  workshop_home_last_update: "Última atualização",
  workshop_home_resp_admin: "Administrativo",
  workshop_home_resp_client: "Cliente",
  workshop_home_resp_workshop: "Oficina",
  workshop_quotations_table_date: "Data",
  workshop_quotations_table_type: "Tipo",
  workshop_quotations_table_value: "Valor",
  workshop_quotations_table_status: "Status",
  workshop_quote_attachments_title: "Anexos e Documentos",
  workshop_quote_attachments_tab: "Anexos",
  workshop_quote_invoices_tab: "Notas Fiscais",
  workshop_quote_add_attachment_btn: "Adicionar Anexo",
  workshop_quote_add_invoice_btn: "Adicionar NF (PDF)",
  workshop_quote_search_label: "ID ou Nome do Equipamento",
  workshop_quote_search_placeholder: "Digite ID ou nome do equipamento...",
  workshop_quote_finance_summary: "Resumo Financeiro",
  workshop_quote_total_items_label: "Total Itens (R$)",
  workshop_quote_discount_label: "Desconto (R$)",
  workshop_quote_total_final_label: "Total Final (R$)",
  workshop_quote_form_no_equip_msg: "Nenhum equipamento adicionado ao orçamento",
  workshop_quote_form_add_item_btn: "Adicionar Item",
  workshop_quote_form_table_qty: "Qtd",
  workshop_quote_form_table_item: "Cod - Nome",
  workshop_quote_item_type_part: "Peça",
  workshop_quote_item_type_service: "Serviço",
  workshop_quote_modal_items_title: "Adicionar Itens ao Serviço",
  workshop_quote_modal_search_label: "Buscar por nome ou código",
  workshop_quote_modal_search_placeholder: "Ex: CTAT001 ou Parafuso",
  workshop_quote_modal_no_items: "Nenhum item encontrado",
  workshop_quote_overlay_normal_price: "Valor normal",
  workshop_quote_overlay_promo_price: "Valor promocional",
  workshop_search_initial_msg: "Informe o que deseja buscar",
  workshop_search_found_companies: "Empresas Encontradas",
  workshop_search_no_companies: "Nenhuma empresa encontrada",
  workshop_search_found_quotes: "Cotações Encontradas",
  workshop_search_no_quotes: "Nenhuma cotação encontrada",
  workshop_search_query_placeholder: "empresa ou cnpj",
  workshop_search_num_placeholder: "nº cotação",
  workshop_respond_id_not_found: "ID da estimativa não encontrado",
  workshop_respond_load_error: "Erro ao carregar dados da estimativa",
  workshop_respond_services_load_error: "Erro ao carregar catálogo de serviços",
  workshop_respond_empty_item_warning: "Adicione pelo menos um item à resposta",
  workshop_respond_sent_msg: "Resposta enviada com sucesso!",
  workshop_respond_success_alert: "Sucesso ao enviar resposta",
  workshop_respond_send_error: "Erro ao enviar resposta",
  workshop_respond_no_estimate_loaded: "Nenhuma estimativa carregada",
  workshop_respond_no_items_msg: "Nenhum item solicitado",
  workshop_respond_obs_label: "Observação adicional",
  workshop_respond_obs_placeholder: "Digite a resposta...",
  workshop_respond_total_value_label: "Valor Total",
  workshop_respond_finish_btn: "Finalizar Resposta",
  workshop_respond_item_details_title: "Detalhes do Item",
  workshop_respond_select_service_title: "Selecionar Serviço",
  workshop_respond_filter_label: "Filtrar serviços",
  workshop_respond_filter_placeholder: "Buscar por nome ou código...",
  workshop_respond_quantity_label: "Quantidade",
  workshop_respond_add_btn: "Adicionar Item",
  workshop_respond_client_data_title: "DADOS DO CLIENTE",
  workshop_respond_estimate_data_title: "DADOS DA ESTIMATIVA",
  workshop_respond_admin_reply_title: "RESPOSTA DO ADMIN",
  workshop_equipaments_title: "Lista de Equipamentos",
  workshop_equipaments_add_btn: "Adicionar",
  workshop_equip_add_load_equip_error: "Não foi possível carregar os dados do equipamento",
  workshop_equip_add_load_services_error: "Não foi possível carregar a lista de serviços",
  workshop_equip_details_download_error: "Erro ao fazer download do arquivo",
  workshop_equip_details_history_title: "Histórico de Revisões",
  workshop_equip_details_id_not_found: "ID do equipamento não encontrado",
  workshop_equip_details_item_data_title: "Dados do Item",
  workshop_equip_details_last_photos_title: "Últimas Fotos do Equipamento",
  workshop_equip_details_load_error: "Erro ao carregar dados do equipamento",
  workshop_equip_details_loading_msg: "Carregando...",
  workshop_equip_details_loading_short_msg: "Carregando...",
  workshop_equip_details_no_data_msg: "Dados do equipamento não disponíveis.",
  workshop_equip_details_try_again_btn: "Tentar Novamente",
  workshop_home_clients_btn: "Clientes",
  workshop_home_equip_not_found: "Equipamento não localizado",
  workshop_home_load_error: "Não foi possível carregar os dados do dashboard",
  workshop_home_loading_msg: "Carregando dados...",
  workshop_home_no_data_msg: "Nenhum dado encontrado para este status",
  workshop_home_operation_phases: "Fases da Operação",
  workshop_home_refresh_btn: "Atualizar",
  workshop_home_reports_btn: "Relatórios",
  workshop_home_responsible_label: "Responsável",
  workshop_home_search_btn: "Buscar",
  workshop_home_search_btn_main: "Pesquisar",
  workshop_home_search_cnpj_nota_label: "Busca por CNPJ ou Numero da Nota",
  workshop_home_search_cnpj_nota_placeholder: "Busca por CNPJ ou Numero da Nota",
  workshop_home_search_note_pending_msg: "Busca por CNPJ ativa. Busca por nota aguardando atualizacao do backend na Home.",
  workshop_home_search_equip_btn_main: "Buscar Equipamento",
  workshop_home_search_equip_label: "Digite o ID do equipamento:",
  workshop_home_search_equip_title: "Buscar Equipamento",
  workshop_home_select_status: "SELECIONE UM STATUS",
  workshop_home_table_client: "Cliente",
  workshop_home_table_cnpj: "CNPJ",
  workshop_home_table_code: "Código",
  workshop_home_table_created: "Criado",
  workshop_home_table_type: "Tipo",
  workshop_quotations_confirm_btn: "Sim, continuar",
  workshop_quotations_create_btn: "Criar Apontamento",
  workshop_quotations_create_warning: "Ao prosseguir, você vai gerar um novo apontamento sem vínculo com nenhuma estimativa. Tem certeza que deseja continuar? (para gerar um apontamento vinculado, faça isso a partir dos detalhes da estimativa)",
  workshop_quotations_finished_title: "Finalizados",
  workshop_quotations_load_error: "Não foi possível carregar as cotações",
  workshop_quotations_loading_msg: "Carregando...",
  workshop_quotations_no_finished_msg: "Nenhum registro finalizado",
  workshop_quotations_no_ongoing_msg: "Nenhum registro em andamento",
  workshop_quotations_no_pending_msg: "Nenhum registro pendente",
  workshop_quotations_ongoing_title: "Em Andamento",
  workshop_quotations_page_title: "Cotações",
  workshop_quotations_pending_title: "Pendente Comigo",
  workshop_quotations_table_local: "Local",
  workshop_quotations_table_ref: "Ref",
  workshop_quote_anexo_deleted_msg: "Anexo excluído com sucesso",
  workshop_quote_delete_anexo_title: "Excluir anexo?",
  workshop_quote_delete_nota_title: "Excluir nota fiscal?",
  workshop_quote_equip_added_warning: "Equipamento já adicionado ao orçamento",
  workshop_quote_form_items_title: "Itens do Orçamento",
  workshop_quote_form_save_btn: "Salvar Orçamento",
  workshop_quote_form_tech_label: "Técnico/Responsável",
  workshop_quote_generate_confirm_btn: "Sim, gerar orçamento",
  workshop_quote_generate_title: "Gerar Orçamento",
  workshop_quote_generate_warning: "Com isso será gerado um orçamento para aprovação administrativa. Tenha certeza de ter incluído todas as peças e procedimentos do serviço. Deseja prosseguir?",
  workshop_quote_no_equip_error: "Adicione pelo menos um equipamento ao orçamento",
  workshop_quote_no_service_linked: "Este equipamento não possui serviço vinculado",
  workshop_quote_nota_deleted_msg: "Nota fiscal excluída com sucesso",
  workshop_quote_remove_equip_title: "Remover equipamento?",
  workshop_quote_remove_item_title: "Remover item?",
  workshop_quote_save_error: "Não foi possível salvar o orçamento",
  workshop_quote_save_success: "Orçamento salvo com sucesso!",
  workshop_quote_service_not_found: "Serviço não encontrado",
  workshop_status_approved: "Aprovado para Manutenção",
  workshop_status_finished: "Status finalizado",
  workshop_status_in_analysis: "Equipamento Em Análise",
  workshop_status_pending_approval: "Pendente de Aprovação",
  workshop_status_ready: "Pronto para Retirada",
  workshop_status_refused: "Status recusado",
  workshop_status_waiting_equip: "Aguardando Equipamento",
  workshop_status_waiting_inspection: "Aguardando Inspeção e Laudo",
  workshop_status_waiting_invoice: "Aguardando Faturamento",
  workshop_status_waiting_quote: "Status aguardando cotacao",
  workshop_breadcrumb_quotations: "Cotações",
  workshop_breadcrumb_quote: "Orçamento",
  workshop_breadcrumb_estimate_respond: "Resposta da estimativa",
  workshop_breadcrumb_search: "Pesquisar",
  workshop_breadcrumb_add_equipment: "Adicionar equipamento",
  // Quick Company + Quotation Modal
  workshop_home_equip_entry_btn: "Entrada de Equipamento",
  workshop_quick_title: "Entrada de Equipamento — Cadastro Rápido",
  workshop_quick_step_company: "Empresa",
  workshop_quick_step_quotation: "Cotação",
  workshop_quick_cnpj: "CNPJ",
  workshop_quick_company_name: "Nome da Empresa",
  workshop_quick_responsible: "Nome do Responsável",
  workshop_quick_email: "E-mail do Responsável",
  workshop_quick_phone: "Telefone",
  workshop_quick_schema_preview: "Schema (gerado automaticamente)",
  workshop_quick_tipo: "Tipo",
  workshop_quick_choice_subtitle: "Escolha como deseja iniciar o atendimento",
  workshop_quick_choice_existing: "Empresa Existente",
  workshop_quick_choice_existing_desc: "Selecione uma empresa já cadastrada",
  workshop_quick_choice_new: "Nova Empresa",
  workshop_quick_choice_new_desc: "Cadastre um novo cliente rapidamente",
  workshop_quick_select_company: "Selecione a empresa",
  workshop_quick_continue: "Continuar",
  workshop_quick_observacoes: "Observações",
  workshop_quick_observacoes_placeholder: "Observações adicionais (opcional)...",
  workshop_quick_local: "Local de Execução",
  workshop_quick_equip_service_title: "Equipamento e Serviço",
  workshop_quick_equipment: "Equipamento",
  workshop_quick_service: "Serviço",
  workshop_quick_select_placeholder: "Selecione...",
  workshop_quick_details_title: "Detalhes",
  workshop_quick_quantity: "Quantidade",
  workshop_quick_model: "Modelo",
  workshop_quick_brand: "Marca",
  workshop_quick_problem: "Problema / Necessidade",
  workshop_quick_problem_placeholder: "Descreva o problema ou necessidade...",
  workshop_quick_cancel: "Cancelar",
  workshop_quick_next: "Cadastrar Empresa e Continuar",
  workshop_quick_finish: "Finalizar",
  workshop_quick_creating: "Processando...",
  workshop_quick_company_success: "Empresa criada com sucesso!",
  workshop_quick_quotation_success: "Cotação criada com sucesso!",
  workshop_quick_error_missing: "Preencha todos os campos obrigatórios.",
  workshop_quick_error_exists: "Grupo de empresa já existe.",
  workshop_quick_error_invalid: "Nome inválido para schema.",
  workshop_quick_error_email_exists: "Este e-mail já existe e não pode ser cadastrado.",
  workshop_quick_error_generic: "Ocorreu um erro. Tente novamente.",
  workshop_status_sent: "Enviado",
  workshop_home_table_header_actions: "Acoes",
  workshop_home_mark_sent_btn: "Marcar como Enviado",
  workshop_home_mark_sent_confirm_title: "Confirmar",
  workshop_home_mark_sent_confirm_text: "Deseja avancar este item para Enviado?",
  workshop_home_mark_sent_success: "Status atualizado para Enviado.",
  workshop_home_mark_sent_error: "Nao foi possivel atualizar para Enviado.",
  workshop_status_authorize_maintenance: "Autorizar Manutencao",
  workshop_home_authorize_maintenance_btn: "Autorizar Manutencao",
  workshop_home_authorize_maintenance_confirm_title: "Confirmar",
  workshop_home_authorize_maintenance_confirm_text: "Deseja avancar este item para Autorizar Manutencao?",
  workshop_home_authorize_maintenance_success: "Status atualizado para Autorizar Manutencao.",
  workshop_home_authorize_maintenance_error: "Nao foi possivel atualizar para Autorizar Manutencao.",
  workshop_home_approve_maintenance_btn: "Aprovar para Manutencao",
  workshop_home_approve_maintenance_confirm_title: "Confirmar",
  workshop_home_approve_maintenance_confirm_text: "Deseja avancar este item para Aprovado para Manutencao?",
  workshop_home_approve_maintenance_success: "Status atualizado para Aprovado para Manutencao.",
  workshop_home_approve_maintenance_error: "Nao foi possivel atualizar para Aprovado para Manutencao.",
}
